import LocalListingBody from '../../../../../../components/Blocks/Listing/ListingBody';

const ListingBody = (props) => {
  return <LocalListingBody {...props} />;
};

export default ListingBody;
